// Boots Datadog RUM on the client: error capture, views, resources,
// Session Replay, and Web Vitals.

import { initDatadogRum } from 'shared/otel/init-datadog-rum'

initDatadogRum('web.legacy')
